import appraiser from "apis/appraiserCounties";
import { WebApiRequest, HTTP_GET } from "tools/webservice";

export const getAppraiserActiveCoverage = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraiser.getAppraiserActiveCoverage(),
  successCallback,
  mountedRef,
});
